import { Module } from '../../services/modules'
import { BreadCrumb } from './types'

export const homepageBreadcrumbs = (modules: Module[]): BreadCrumb => {
  const breadcrumbPhrase = modules.includes('CommunityOverviewOpenForAllUsers')
    ? 'breadcrumb.homepage.community_overview_active_text'
    : 'breadcrumb.homepage.text'

  return {
    phrase: ['Common', breadcrumbPhrase],
    url: '/'
  }
}
